import { UserStatusFragmentGql } from '@haaretz/s-fragments/UserStatus';
import { useQuery, useInfiniteQuery } from '@tanstack/react-query';
import { fetch } from '@haaretz/s-graphql-fetcher';
export const CheckEmailExistPersonalQueryDocument = `
    query CheckEmailExistPersonalQuery($email: String!, $site: Site!) {
  user: userLogin(email: $email) {
    ssoId: _id
    mobilePhone
    isPaying(site: $site)
    termsCheck(site: $site)
    userStatus {
      ...UserStatusFragment
    }
  }
}
    ${UserStatusFragmentGql}`;
export const useCheckEmailExistPersonalQuery = (variables, options)=>useQuery([
        'CheckEmailExistPersonalQuery',
        variables
    ], fetch(CheckEmailExistPersonalQueryDocument, variables), options);
useCheckEmailExistPersonalQuery.document = CheckEmailExistPersonalQueryDocument;
useCheckEmailExistPersonalQuery.getKey = (variables)=>[
        'CheckEmailExistPersonalQuery',
        variables
    ];
export const useInfiniteCheckEmailExistPersonalQuery = (pageParamKey, variables, options)=>{
    return useInfiniteQuery([
        'CheckEmailExistPersonalQuery.infinite',
        variables
    ], (metaData)=>fetch(CheckEmailExistPersonalQueryDocument, {
            ...variables,
            ...metaData.pageParam ?? {}
        })(metaData), options);
};
useInfiniteCheckEmailExistPersonalQuery.getKey = (variables)=>[
        'CheckEmailExistPersonalQuery.infinite',
        variables
    ];
useCheckEmailExistPersonalQuery.fetcher = (variables, options)=>fetch(CheckEmailExistPersonalQueryDocument, variables, options);

//# sourceMappingURL=CheckEmailExist.js.map